export default "__VITE_ASSET__DPB$gRAK__"